module.exports = __webpack_public_path__ + "static/img/图层19.901008e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/facilitator/图层19.png
// module id = XAkh
// module chunks = 0